import * as PropTypes from 'prop-types';
import * as React from 'react';
import TooltipPanel from '@reverbdotcom/commons/dist/components/tooltip_panel';
import UrlHelpers from '../shared/url_helpers';
import * as classNames from 'classnames';
import { SanitizedRender } from '@reverbdotcom/discovery-ui';

class Sale extends React.Component {
  get slug() {
    return this.props.sale.slug;
  }

  get description() {
    return this.props.sale.description;
  }

  get sanitizedCode() {
    return <SanitizedRender html={this.props.sale.code} />;
  }

  get finePrint() {
    return I18n.t('digitalListing.sale.instantDiscount');
  }

  render() {
    const sectionClasses = classNames(
      'module',
      'purchase-module-header',
      'bd-rounded',
      'btm-square-module',
      'align-center',
      'new-sidebar-sale',
    );

    return (
      <section
        className={sectionClasses}
      >
        <div className="divider mt-half mobile-mt-1" />
        <TooltipPanel
          type="plain"
          text={I18n.t('digitalListing.sale.saleToolTip')}
        >
          <div className="huge sale-accent">
            <span className="fa fa-tag" />
          </div>
          <div className="sale-detail">
            <span>
              <span className="sale-detail__save">
                {this.description}
              </span>
              <br />
              <span
                className="sale-detail__instant-discount"
                dangerouslySetInnerHTML={{ __html: this.finePrint }}
              />
            </span>
            <div className="pt-half mobile-mb-half">
              <a
                className="sale-detail__shop-more"
                href={UrlHelpers.salePath(this.slug)}
              >
                {I18n.t('digitalListing.sale.saleLink')}
              </a>
            </div>
          </div>
        </TooltipPanel>
      </section>
    );
  }
}

Sale.propTypes = {
  sale: PropTypes.object.isRequired,
};


export default Sale;



// WEBPACK FOOTER //
// ./javascripts/components/digital_listings/sale.jsx